<template>
  <div class="context-menu" :style="style">
      <ul>
          <li v-for="(menuItem, index) in state.menuItems" v-bind:key="index" @click.stop="onClick(menuItem)">{{ menuItem.title }}</li>
      </ul>
  </div>
</template>

<script>
export default {
  name: 'ContextMenu',
  computed: {
    state() {
          return this.$store.state.ui.contextMenuState
    },
    style() {
        return {
            top: this.state.top,
            left: this.state.left,
            right: this.state.right,
            opacity: this.state.active ? 1 : 0,
            pointerEvents: this.state.active ? 'initial' : 'none'
        }
    }
  },
  methods: {
      documentClick() {
          this.$store.commit("ui/contextMenuActive", false)
      },
      onClick(menuItem) {
          if (menuItem.handler) {
              menuItem.handler()
          }
          this.$store.commit("ui/contextMenuActive", false)
      }
  },
  watch: {
      state: function(newValue) {
          if (newValue.active) {
              document.addEventListener("click", this.documentClick)
          } else {
              document.removeEventListener("click", this.documentClick)
          }
      }
  }
}
</script>

<style scoped>
.context-menu {
    background: var(--c-button-blue);
    border-radius: 7px;
    color: #fff;
    position: fixed;
    z-index: 999;
    padding: 0 0px;
    transition: opacity 0.5s ease-in-out;
    min-width: max-content;
}
ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
}
li {
    height: 48px;
    border-bottom: 1px solid var(--c-medium-grey-menu-divider);
    font-weight: 300;
    padding: 14px 60px 0 20px;
    text-align: left;
}
li:first-child {
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
}

li:last-child {
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
}

li:hover {
    background: var(--c-hover-blue);

}
.divider {

}
</style>
